export const productDescriptionReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      return { ...state, [action.field]: action.value };
    case "SET_ERROR":
      return { ...state, error: action.value };
    case "SET_HELPER_TEXT":
      return { ...state, helperText: action.value };
    case  "VALIDATE_INPUT_ERROR":
      return { ...state, errors: { ...state.errors, [action.field]: action.value } };  
    default:
      return state;
  }
};